import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import LineupPlayersSnippetNotFoundError from './lineup-players-snippet-not-found-error';
import {lineupPlayersSnippetMap} from 'components/organisms/late-swap/services/maps';

const LineupPlayersSnippetFactory = {
    getSnippet(sportConfig): ArraySnippetInterface {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        try {
            return lineupPlayersSnippetMap[site][sport][gameType]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new LineupPlayersSnippetNotFoundError('Snippet is undefined');
            }
            throw e;
        }
    },
};

export default LineupPlayersSnippetFactory;
